import { render, staticRenderFns } from "./DrawerListProducts.vue?vue&type=template&id=e79d59bc&scoped=true&"
import script from "./DrawerListProducts.vue?vue&type=script&lang=js&"
export * from "./DrawerListProducts.vue?vue&type=script&lang=js&"
import style0 from "./DrawerListProducts.vue?vue&type=style&index=0&id=e79d59bc&prod&lang=sass&scoped=true&"
import style1 from "./DrawerListProducts.vue?vue&type=style&index=1&id=e79d59bc&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e79d59bc",
  null
  
)

export default component.exports